import { Button, Paragraph, Table } from "@digdir/designsystemet-react";
import clsx from "clsx";
import { Medal } from "@/components/athlete-overview-page/athlete-dialog/medal";
import { useState } from "react";
import { AthleteDialogAthleteProps } from "@/components/athlete-overview-page/athlete-dialog/types";
import { UseAthleteOverview } from "@/components/athlete-overview-page/athlete-overview-page-provider";


export function ResultTable(athlete: AthleteDialogAthleteProps) {
    const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
    const { updateSearchParams } = UseAthleteOverview()

    const toggleRow = (eventId: string) => {
        setExpandedRows(prev => ({
            ...prev,
            [eventId]: !prev[eventId]
        }));
    };
    const handleOnClose = () => updateSearchParams({ fisCode: null })

    const sortedAthleteList = athlete.athlete_results?.sort((a, b) => new Date(b.event_date).getTime() - new Date(a.event_date).getTime())

    return (
        <div className="flex-1 flex flex-col h-full sm:overflow-hidden">
            <div className="hidden sm:flex justify-end p-4">
                <Button type={"button"} onClick={handleOnClose} variant="tertiary"
                    className="text-neutral-text-default size-5 flex items-center justify-center rounded-full overflow-hidden ">
                    <span aria-hidden="true" className="material-symbols-rounded ">close</span>
                </Button>
            </div>

            <div className="flex-1 px-4 pb-4 overflow-y-hidden">
                <Paragraph data-size="xl" className="mb-4">Resultater</Paragraph>

                <div className="max-h-[calc(100%-4rem)] overflow-y-auto">
                    <Table className="min-w-full">
                        <Table.Head className="text-neutralNsf sticky top-0 bg-white z-50">
                            <Table.Row>
                                <Table.Cell>Plassering / Event</Table.Cell>
                                <Table.Cell className="text-nowrap">Total tid</Table.Cell>
                                <Table.Cell>Tid bak</Table.Cell>
                                <Table.Cell className="text-nowrap">Tid bak topp 3</Table.Cell>
                                <Table.Cell className="text-nowrap">Poeng</Table.Cell>
                                <Table.Cell className="text-nowrap"></Table.Cell>
                            </Table.Row>
                        </Table.Head>
                        <Table.Body>
                            {sortedAthleteList?.map(result => {
                                const isExpanded = expandedRows[result.event_id];
                                return (
                                    <React.Fragment key={result.event_id}>
                                        <Table.Row
                                            className={clsx(
                                                "bg-white border-b border-neutralNsf cursor-pointer hover:bg-neutralNsf-subtle",
                                                { "bg-brand-detail-gray-light": isExpanded }
                                            )}
                                            onClick={() => toggleRow(result.event_id)}
                                        >
                                            <Table.Cell>
                                                <div className="flex gap-2 items-center">
                                                    <Medal rank={result.class_rank} />
                                                    <div className="flex flex-col !text-xs">
                                                        <b>{result.event_name}</b>
                                                        <span>
                                                            {new Date(result.event_date).toLocaleDateString("no-NO", {
                                                                day: "2-digit",
                                                                month: "2-digit",
                                                                year: "numeric"
                                                            })}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Table.Cell>
                                            <Table.Cell>{result.total_time}</Table.Cell>
                                            <Table.Cell>{result.time_behind}</Table.Cell>
                                            <Table.Cell>
                                                <span>{result.time_behind_top_three}</span>
                                            </Table.Cell>
                                            <Table.Cell>{result.class_points}</Table.Cell>
                                            <Table.Cell>
                                                <span aria-hidden="true"
                                                    className={clsx("material-symbols-rounded",
                                                        isExpanded ? "rotate-0" : "rotate-180")}
                                                >
                                                    stat_1
                                                </span>
                                            </Table.Cell>
                                        </Table.Row>

                                        {isExpanded && (
                                            <Table.Row
                                                className="border-b border-neutralNsf bg-brand-detail-gray-light">
                                                <Table.Cell colSpan={2} className="align-top">
                                                    <Paragraph className="flex flex-col gap-1 !text-xs">
                                                        <span>Løypesektorer</span>
                                                        <b>Sektor 1: {result.sector_1_km}</b>
                                                        <b>Sektor 2: {result.sector_2_km}</b>
                                                        <b>Sektor 3: {result.sector_3_km}</b>
                                                    </Paragraph>
                                                </Table.Cell>
                                                <Table.Cell className="align-top">
                                                    <Paragraph className="flex flex-col gap-1 !text-xs">
                                                        <span>Plassering</span>
                                                        <b>{result.sector_1_rank}</b>
                                                        <b>{result.sector_2_rank}</b>
                                                        <b>{result.sector_3_rank}</b>
                                                    </Paragraph>
                                                </Table.Cell>
                                                <Table.Cell className="align-top">
                                                    <Paragraph className="flex flex-col gap-1 !text-xs">
                                                        <span>Tid bak</span>
                                                        <b>{result.sector_1_time_behind}</b>
                                                        <b>{result.sector_2_time_behind}</b>
                                                        <b>{result.sector_3_time_behind}</b>
                                                    </Paragraph>
                                                </Table.Cell>
                                                <Table.Cell className="align-top">
                                                    <Paragraph className="flex flex-col gap-1 !text-xs">
                                                        <span>Tid</span>
                                                        <b>{result.sector_1_time}</b>
                                                        <b>{result.sector_2_time}</b>
                                                        <b>{result.sector_3_time}</b>
                                                    </Paragraph>
                                                </Table.Cell>
                                            </Table.Row>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </div>
    )
}